module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ajLVP"))).then(() => module.bundle.root('dsisd'));